import JsonLd from 'lib/json-ld/JsonLd'

export default class VideoJsonLd extends JsonLd {
  // TODO: add required fields for VideoObject
  // ref: https://developers.google.com/search/docs/appearance/structured-data/video#video-object
  // We may want to add uploadDate and description but our sanity schema doesn't support it, will consider adding it when we move to SSR
  // We can get youtube video detail from getServerData or getServerProps on Next.js. We could also use the YouTube API to get the video detail.
  // TODO: go through the above link and add other fields that are not required but recommended
  // the more we can add here, the better it is for SEO.
  constructor (title, description, videoId, type) {
    super('VideoObject')
    this.name = title
    this.description = description
    switch (type) {
      case 'Youtube':
        this.thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
        this.embedUrl = `https://www.youtube.com/embed/${videoId}`
        this.contentUrl = `https://www.youtube.com/watch?v=${videoId}`
        break
      default:
        throw new Error('Invalid type for VideoJSONLD')
    }
  }

  static create ({ title, description, videoId, type = 'Youtube' }) {
    return new VideoJsonLd(title, description, videoId, type)
  }
}
